<div class="row-btn-species" matRipple>
    <div class="species-icon" [hidden]="iconName == undefined">
        <img [src]="'assets/icons/'+iconName+'.svg'" alt="icnRight">
    </div>
    <div class="species-info d-flex flex-column" >
        <div [innerHTML]="tableLayout"></div>

        @if(displayData?.examinations){
            <div class="d-flex flex-row flex-wrap">
                <div *ngFor="let exam of displayData.examinations; let index = index" class="p-1" >
                    <span class="p-1 rounded-pill mr-1" [style.background-color]="exam.result ? (exam.result === 'positiv' ? 'rgb(255 0 0 / 50%)' : (exam.result === 'negativ' ? 'rgb(0 128 0 / 50%)' : 'rgba(255, 255, 0, 0.3)')) : 'rgb(128 128 128 / 50%)'" style="font-size: 10px;line-height: 2;">{{exam?.examinationDisease}}</span>
                </div>
            </div>
        }
    </div>
    <!-- <div class="species-info" [innerHTML]="tableLayout"></div> -->
    <div class="indicator-icon">
        <button mat-icon-button>
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
</div>